var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666656 1.99967C0.666656 1.0792 1.41285 0.333008 2.33332 0.333008H11.5C14.7217 0.333008 17.3333 2.94468 17.3333 6.16634V11.8924C17.3333 12.4119 16.9122 12.833 16.3927 12.833H15.6371C15.4349 14.2465 14.2194 15.333 12.75 15.333C11.2806 15.333 10.065 14.2465 9.86286 12.833H7.30379C7.10161 14.2465 5.88602 15.333 4.41666 15.333C3.20938 15.333 2.17343 14.5995 1.73013 13.5538C1.10781 13.3121 0.666656 12.7074 0.666656 11.9997V8.66634V6.99967V1.99967ZM7.05264 11.1663H10.114C10.4021 10.5598 10.8935 10.0685 11.5 9.78035V8.66634H2.33332V10.3751C2.86271 9.83487 3.60054 9.49967 4.41666 9.49967C5.58016 9.49967 6.58453 10.1809 7.05264 11.1663ZM11.5 12.4163C11.5 13.1067 12.0596 13.6663 12.75 13.6663C13.4403 13.6663 14 13.1067 14 12.4163C14 11.726 13.4403 11.1663 12.75 11.1663C12.0596 11.1663 11.5 11.726 11.5 12.4163ZM2.33332 6.99967H11.5L11.5 1.99967L2.33332 1.99967V6.99967ZM13.1667 9.52921C14.1498 9.66984 14.9748 10.3008 15.386 11.1663H15.6667V6.99967H13.1667V9.52921ZM13.1667 5.33301H15.5833C15.3107 3.99024 14.3924 2.88195 13.1667 2.34638V5.33301ZM4.41666 11.1663C3.7263 11.1663 3.16666 11.726 3.16666 12.4163C3.16666 13.1067 3.7263 13.6663 4.41666 13.6663C5.10701 13.6663 5.66666 13.1067 5.66666 12.4163C5.66666 11.726 5.10701 11.1663 4.41666 11.1663Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.290df5e8448a7560a0824f8449c763db.svg";
export { ForwardRef as ReactComponent };